import { useRef } from "react";
import dayjs from "dayjs";
import Styles from "./AppInputDate.module.scss";
import Column from "../Column";
import Row from "../Row";
import Title from "../Title";
import { DatePicker, DatePickerProps } from "antd";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc); // 👈 bắt buộc phải có

interface AppInputDateProps extends DatePickerProps {
  isShowTime?: boolean;
  orientation?: "col" | "row";
  textColor?: string;
  label?: string;
  currentValue: number | undefined;
  onChangeValue?: (value: number | undefined) => void;
  isRequired?: boolean;
  errorText?: string;
  alwaysShowLabel?: boolean;
}

function AppInputDate(props: AppInputDateProps) {
  const {
    currentValue,
    label,
    isRequired,
    onChangeValue,
    errorText,
    alwaysShowLabel = true,
    isShowTime = true,
    orientation = "row",
    textColor,
    ...rest
  } = props;

  const refCalendar = useRef<any>(null);

  const Wrap = orientation === "row" ? Row : Column;

  return (
    <Column className="w-100 h-100">
      <Wrap className={"w-100 h-100 gap-1"}>
        {alwaysShowLabel && label && <Title isRequired={isRequired} label={label} vertical={orientation === 'col'}/>}
        <DatePicker
          ref={refCalendar}
          className={`${Styles.appInputDate} w-100 align-items-center `}
          status={!!errorText ? "error" : ""}
          showTime={isShowTime}
          format={isShowTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD"}
          value={currentValue ? dayjs(currentValue) : null}
          onChange={(value) => {
            onChangeValue?.(value ? dayjs(value?.toDate())?.utc()?.valueOf() : undefined);
          }}
          needConfirm
          {...rest}
        />
      </Wrap>

      {errorText && (
        <small
          className={`${Styles.smallTextError} text-error pb-1`}
          style={!alwaysShowLabel || !label || orientation === "col" ? {} : { marginLeft: 120 }}
        >
          {errorText}
        </small>
      )}
    </Column>
  );
}

export default AppInputDate;
